import { network } from './network'

/**
* @ignore
*/
const config = {
  network: network.defaults.MAINNET_DEFAULT,
  logLevel: 'debug'
}

export { config }
